import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore, notificationStore, useTranslation } from '@pascal/pascal-core';
import { gameConfigStore, freeBetStore, betStore } from '@pascal/pascal-core/shared/core/store';
import { betDataStore, doBetStore, gameStore } from '../../../../store';
import { globalTranslationKeys } from '../../../../enums';
import { DoBetButton } from './doBetBtn';

export const DoBet = observer(({ gameTypeId }) => {
  const { doBetSender, sendCashOut, doBetSectionsData, cashOutDisabled, freeBetMinOdd } =
    doBetStore;
  const { isBetsClosedByGameType, partnerWageringOdd, defaultMinOdd } = gameStore;
  const { activeFreeBet } = freeBetStore;
  const { isBetAccepted, isBetPending, isDisabled, freeBetId } = doBetSectionsData[gameTypeId];
  const cashOutDisable = cashOutDisabled[gameTypeId];
  const { minBet, defaultBetAmount } = gameConfigStore.limits;
  const { repliedBetData } = betStore;
  const { isDemo } = applicationStore;
  const t = useTranslation();
  const { Bet, CashOut, MinOdd, FreeBets } = globalTranslationKeys;

  useEffect(() => {
    if (activeFreeBet.id) {
      betDataStore.setBetAmount(activeFreeBet.amount, gameTypeId);
      betDataStore.setAutoCashOutOdd(activeFreeBet.minOdd, gameTypeId);
      betDataStore.autoBetsAndAutoCashOutsTurnOf();
    }
    if (!activeFreeBet.id && !repliedBetData) {
      betDataStore.setBetAmount(defaultBetAmount || minBet, gameTypeId);
      betDataStore.setAutoCashOutOdd(defaultMinOdd, gameTypeId);
      betDataStore.autoBetsAndAutoCashOutsTurnOf();
    }
  }, [activeFreeBet.id]);

  const cashOutClassname = isBetAccepted ? 'cash-out' : '';

  const handleDoBetEvents = useCallback(() => {
    if (!isBetsClosedByGameType[gameTypeId]) {
      if (notificationStore.notificationCode?.responseCode > 0) {
        setTimeout(() => notificationStore.setNotificationType(0), 500);
        return;
      }
      doBetSender(gameTypeId);
    } else if (isBetAccepted && isBetsClosedByGameType[gameTypeId]) {
      sendCashOut(gameTypeId);
    }
  }, [gameTypeId, isBetAccepted, isBetsClosedByGameType[gameTypeId]]);

  const disabledBtn =
    isBetPending ||
    (isBetsClosedByGameType[gameTypeId] && !isBetAccepted) ||
    (!isBetsClosedByGameType[gameTypeId] && isBetAccepted) ||
    cashOutDisable ||
    (isBetAccepted && isDisabled)
      ? 'disabled'
      : '';
  const isPulseAnim = !disabledBtn && !isBetAccepted && 'pulse-anim';

  const betBtnText = isBetAccepted
    ? CashOut
    : (activeFreeBet.id || freeBetId) && !isDemo
    ? FreeBets
    : Bet;

  const additionalBtnInfo =
    (!isBetAccepted && activeFreeBet.minOdd && !activeFreeBet.isMinOddNull) ||
    (freeBetId &&
      freeBetMinOdd &&
      !freeBetStore.freeBets.find((item) => item.id === freeBetId)?.isMinOddNull) ? (
      <p className='btn-game-small-txt'>
        {` ${t(MinOdd)} x${activeFreeBet.minOdd || freeBetMinOdd}`}
      </p>
    ) : partnerWageringOdd && !isDemo ? (
      <p className='btn-game-small-txt'> {` ${t(MinOdd)} x${partnerWageringOdd}`} </p>
    ) : null;

  const freeBetRemainingCount = betBtnText === FreeBets ? activeFreeBet.remainingCount : '';
  return (
    <DoBetButton
      gameTypeId={gameTypeId}
      handleDoBetEvents={handleDoBetEvents}
      disabledBtn={disabledBtn}
      betBtnText={betBtnText}
      freeBetRemainingCount={freeBetRemainingCount}
      cashOutClassname={cashOutClassname}
      isPulseAnim={isPulseAnim}
      additionalBtnInfo={additionalBtnInfo}
      isFreeBetDisabled={isDisabled}
      t={t}
    />
  );
});
